import { Box, Typography } from "@mui/material";
import { useState } from "react";

import useAPI from "../../../../../../api/hooks/useAPI";
import TextWithExternalLink from "../../../../../../components/ExternalLink";
import { ComplexEntityTypes } from "../../../../../../utils/constants";
import { useEntities } from "../../../hooks/useEntities";
import EntityDrawer from "../../EntityDrawer/EntityDrawer";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import RelatedUserSection from "./RelatedUserSection";

export default function SalesforceOAuthTokenDetailsView({ entityData }) {
  const [entityForDrawer, setEntityForDrawer] = useState(null);
  const { useQueryForEntitiesByType } = useEntities();

  const { data: appEntities } = useQueryForEntitiesByType({
    type: ComplexEntityTypes.APP,
    enabled: Boolean(entityData?.salesforce_oauth_token_data?.connected_app_id),
  });

  const { trackEvent } = useAPI();

  const appEntity =
    appEntities &&
    entityData?.salesforce_oauth_token_data?.connected_app_id &&
    appEntities.find(
      (entity) =>
        entity.unique_id ===
        entityData.salesforce_oauth_token_data.connected_app_id
    );

  const onAppClick = () => {
    trackEvent(
      `User clicked on app ${entityData?.salesforce_oauth_token_data?.app_name}, from app details view ${entityData?.display_name}`
    );
    setEntityForDrawer(appEntity);
  };

  return (
    <Box>
      <Box display="flex" flexDirection="column" gap={2}>
        {entityData?.salesforce_oauth_token_data?.app_name && (
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Application Name</Typography>
            </Box>
            <Box ml={2} display="flex">
              <TextIntegrationStyle
                title=""
                value={entityData.salesforce_oauth_token_data.app_name}
                onClick={appEntity ? onAppClick : undefined}
                style={
                  appEntity
                    ? {
                        cursor: "pointer",
                        textDecoration: "underline",
                      }
                    : {}
                }
                tooltipTitle={
                  appEntity ? "Click to view app details" : undefined
                }
              />
            </Box>
          </Box>
        )}
        {entityData?.salesforce_oauth_token_data?.app_type && (
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Application Type</Typography>
            </Box>
            <Box ml={2} display="flex">
              <TextIntegrationStyle
                value={entityData.salesforce_oauth_token_data.app_type}
              />
            </Box>
          </Box>
        )}
        {entityData?.salesforce_oauth_token_data?.user_email && (
          <>
            {entityData?.connected_email ? (
              <RelatedUserSection
                entityData={entityData}
                contextName="app details view"
              />
            ) : (
              <Box display="flex" flexDirection="column" gap={1}>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  gap={1}
                >
                  <Typography variant="subtitle2">Authorized By</Typography>
                </Box>
                <Box ml={2} display="flex">
                  <TextIntegrationStyle
                    title=""
                    value={
                      entityData?.salesforce_oauth_token_data?.user_name ||
                      entityData?.salesforce_oauth_token_data?.user_email
                    }
                  />
                </Box>
              </Box>
            )}
          </>
        )}
        {entityData?.salesforce_oauth_token_data?.use_count > 0 && (
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Use count</Typography>
            </Box>
            <Box ml={2}>
              <TextIntegrationStyle
                title=""
                value={entityData?.salesforce_oauth_token_data?.use_count}
              />
            </Box>
          </Box>
        )}
        {entityData?.salesforce_oauth_token_data?.app_has_session_policy !==
          undefined && (
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Has Session Policy</Typography>
            </Box>
            <Box ml={2}>
              <TextIntegrationStyle
                title=""
                value={
                  entityData.salesforce_oauth_token_data.app_has_session_policy
                    ? "Yes"
                    : "No"
                }
              />
            </Box>
          </Box>
        )}
        {entityData?.salesforce_oauth_token_data?.app_info_url && (
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Info URL</Typography>
            </Box>
            <Box ml={2}>
              <TextWithExternalLink
                text=""
                linkText="Application Info URL"
                href={entityData?.salesforce_oauth_token_data?.app_info_url}
              />
            </Box>
          </Box>
        )}
      </Box>
      <EntityDrawer
        openDrawer={entityForDrawer}
        selectedEntity={entityForDrawer}
        onClose={() => {
          setEntityForDrawer(null);
        }}
      />
    </Box>
  );
}
